import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type FreightLineRecord = QueryAtomResult<
  typeof freightLinesQueryAtom
>['freightLines'][number];

export const freightLinesQueryAtom = createQueryAtomFactory(
  'trade.freightLines',
  (params?: { searchTerm?: string; facilityIds?: string[] }) => ({
    freightLines: {
      __args: {
        filter: {
          ...(params?.searchTerm && { searchTerm: params.searchTerm }),
          ...(params?.facilityIds && { facilityIds: params.facilityIds }),
        },
        pagination: {
          offset: 0,
          limit: 200,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data) => ({
      freightLines:
        data?.freightLines.entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
        })) ?? [],
    }),
  },
);
